module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "projects-list-search-container"
  }, [_c('ul', {
    staticClass: "list-unstyled"
  }, [(_vm.isListEmpty) ? _c('li', {
    staticClass: "section-empty",
    class: {
      'section-failure': _vm.searchFailed
    }
  }, [_vm._v("\n      " + _vm._s(_vm.listEmptyMessage) + "\n    ")]) : _vm._l((_vm.projects), function(project, index) {
    return _c('projects-list-item', {
      key: index,
      attrs: {
        "project-id": project.id,
        "project-name": project.name,
        "namespace": project.namespace,
        "web-url": project.webUrl,
        "avatar-url": project.avatarUrl,
        "matcher": _vm.matcher
      }
    })
  })], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-740ed45d"}!/var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./projects_dropdown/components/projects_list_search.vue
// module id = ../../../node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-740ed45d"}!../../../node_modules/vue-loader/lib/selector.js?type=template&index=0!./projects_dropdown/components/projects_list_search.vue
// module chunks = main